// Generated by ReScript, PLEASE EDIT WITH CARE

import * as CssJs from "bs-css-emotion/src/CssJs.bs.js";
import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as React from "react";
import * as Atom_Label from "../atom/Atom_Label.bs.js";
import * as Caml_option from "@rescript/std/lib/es6/caml_option.js";
import * as Css_Js_Core from "bs-css/src/Css_Js_Core.bs.js";
import * as Particle_Css from "../particle/Particle_Css.bs.js";
import * as Particle_zIndex from "../particle/Particle_zIndex.bs.js";
import * as Particle_Screen_Ds from "../particle/Particle_Screen_Ds.bs.js";

var base = {
  label: Atom_Label.base,
  zIndex: undefined
};

function direct(dotColor) {
  return {
          label: Atom_Label.direct(dotColor),
          zIndex: undefined
        };
}

function live(dotColor) {
  return {
          label: Atom_Label.live(dotColor),
          zIndex: undefined
        };
}

var highlight = {
  label: Atom_Label.highlight,
  zIndex: undefined
};

var time = {
  label: Atom_Label.time,
  zIndex: undefined
};

var disabledTime_zIndex = {
  TAG: /* Exact */0,
  _0: /* StickerDisabledTime */15
};

var disabledTime = {
  label: Atom_Label.disabledTime,
  zIndex: disabledTime_zIndex
};

var base_label = Atom_Label.Atom_Label_Ds.TeaserGuide.base;

var base$1 = {
  label: base_label,
  zIndex: undefined
};

function direct$1(dotColor) {
  return {
          label: Curry._1(Atom_Label.Atom_Label_Ds.TeaserGuide.direct, dotColor),
          zIndex: undefined
        };
}

function live$1(dotColor) {
  return {
          label: Curry._1(Atom_Label.Atom_Label_Ds.TeaserGuide.live, dotColor),
          zIndex: undefined
        };
}

var time_label = Atom_Label.Atom_Label_Ds.TeaserGuide.time;

var time$1 = {
  label: time_label,
  zIndex: undefined
};

var disabledTime_label = Atom_Label.Atom_Label_Ds.TeaserGuide.disabledTime;

var disabledTime_zIndex$1 = {
  TAG: /* Exact */0,
  _0: /* StickerDisabledTime */15
};

var disabledTime$1 = {
  label: disabledTime_label,
  zIndex: disabledTime_zIndex$1
};

var Guide = {
  base: base$1,
  direct: direct$1,
  live: live$1,
  time: time$1,
  disabledTime: disabledTime$1
};

function view(param) {
  return {
          label: param.label,
          zIndex: param.zIndex
        };
}

var Molecule_Sticker_Ds = {
  base: base,
  direct: direct,
  live: live,
  time: time,
  disabledTime: disabledTime,
  highlight: highlight,
  topTeaser: time,
  followNext: time,
  Guide: Guide,
  view: view
};

var spacerPosition = Particle_Screen_Ds.make(undefined, "XS", undefined, undefined, undefined, "XXS");

function toCss(t, position) {
  var zIndex = t.zIndex;
  var spacerPosition$1 = Particle_Screen_Ds.map(Particle_Css.spacerSizeInside, spacerPosition);
  var optionalRules = zIndex !== undefined ? Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, [Particle_zIndex.Particle_zIndex_Css.toCss(zIndex)]) : Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, []);
  var positionRules;
  switch (position) {
    case /* BottomRight */0 :
        positionRules = Particle_Screen_Ds.map((function (spacer) {
                return [
                        CssJs.right(spacer),
                        CssJs.bottom(spacer),
                        CssJs.position(CssJs.absolute)
                      ];
              }), spacerPosition$1);
        break;
    case /* TopLeft */1 :
        positionRules = Particle_Screen_Ds.map((function (spacer) {
                return [
                        CssJs.left(spacer),
                        CssJs.top(spacer),
                        CssJs.position(CssJs.absolute),
                        CssJs.maxWidth(Css_Js_Core.Calc.$neg(CssJs.pct(100), Css_Js_Core.Calc.$plus(spacer, spacer)))
                      ];
              }), spacerPosition$1);
        break;
    case /* BottomLeft */2 :
        positionRules = Particle_Screen_Ds.map((function (spacer) {
                return [
                        CssJs.left(spacer),
                        CssJs.bottom(spacer),
                        CssJs.position(CssJs.absolute)
                      ];
              }), spacerPosition$1);
        break;
    case /* Inherit */3 :
        positionRules = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, []);
        break;
    
  }
  return Particle_Screen_Ds.$$Array.concat(optionalRules, positionRules);
}

var Molecule_Sticker_Css = {
  toCss: toCss
};

function Molecule_Sticker(Props) {
  var text = Props.text;
  var styleOpt = Props.style;
  var position = Props.position;
  var id = Props.id;
  var style = styleOpt !== undefined ? Caml_option.valFromOption(styleOpt) : base;
  var view$1 = view(style);
  var rules = toCss(view$1, position);
  var tmp = {
    text: text,
    style: view$1.label,
    rules: rules
  };
  if (id !== undefined) {
    tmp.id = Caml_option.valFromOption(id);
  }
  return React.createElement(Atom_Label.make, tmp);
}

var make = Molecule_Sticker;

export {
  Molecule_Sticker_Ds ,
  spacerPosition ,
  Molecule_Sticker_Css ,
  make ,
}
/* spacerPosition Not a pure module */
